/* eslint-disable camelcase */
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { callApi } from "../../api";
import { parseJSON } from "../../utility/CustomFunction";
import { useAuth } from "../useAuth";

export default () => {
  const { selectedBusiness } = useAuth();

  const [customerSegments, setCustomerSegments] = useState(undefined);

  const getCustomerSegments = async () => {
    const res = await callApi(
      `/protected/business/${
        selectedBusiness?.id
      }/iorequest?dest=${encodeURIComponent(
        "customer/segment/business/:BID:/user/:UID:/get"
      )}`
    );
    if (res?.status) {
      setCustomerSegments(res.data);
    } else setCustomerSegments(undefined);

    return res;
  };

  const getMultiBusinessSegments = async (id) => {
    const res = await callApi(
      `/protected/business/${
        selectedBusiness?.id
      }/iorequest?dest=${encodeURIComponent(
        `customer/segment/${id}/business/:BID:/user/:UID:/getall`
      )}`
    );
    return res;
  };

  const updateCache = (data) => {
    // setCustomerSegments({
    //   ...customerSegments,
    //   userQueries: customerSegments.userQueries?.find?.(
    //     (el) => el.id === data.id
    //   )
    //     ? customerSegments.userQueries.map((el) =>
    //         el.id === data.id ? data : el
    //       )
    //     : customerSegments.userQueries,
    //   businessQueries: customerSegments.businessQueries?.find?.(
    //     (el) => el.id === data.id
    //   )
    //     ? customerSegments.businessQueries.map((el) =>
    //         el.id === data.id ? data : el
    //       )
    //     : customerSegments.businessQueries,
    //   legacyQueries: customerSegments.legacyQueries?.find?.(
    //     (el) => el.id === data.id
    //   )
    //     ? customerSegments.legacyQueries.map((el) =>
    //         el.id === data.id ? data : el
    //       )
    //     : customerSegments.legacyQueries,
    // });
    const newData = {
      ...data,
      last_searched:
        data.last_searched !== undefined
          ? parseJSON(data.last_searched, true)
          : undefined,
      query_parameters:
        data.query_parameters !== undefined
          ? parseJSON(data.query_parameters, true)
          : undefined,
    };
    setCustomerSegments(
      customerSegments.map((el) =>
        el.id === data?.id ? { ...el, ...newData } : el
      )
    );
  };

  const addCustomerSegment = async ({
    name,
    description,
    query_parameters,
    last_searched,
    businessList,
  }) => {
    const res = await callApi(
      `/protected/business/${
        selectedBusiness?.id
      }/iorequest?dest=${encodeURIComponent(
        "customer/segment/business/:BID:/user/:UID:/add"
      )}`,
      "POST",
      { name, description, query_parameters, last_searched, businessList }
    );
    if (res.status) {
      toast.success("Successfully added customer segment");
      //   const newSegment = res.data;
      //   setCustomerSegments({
      //     ...customerSegments,
      //     userQueries: [...(customerSegments.userQueries || []), newSegment],
      //   });
      getCustomerSegments();
    } else {
      toast.error("Failed to add customer segment");
    }
    return res;
  };

  const removeCustomerSegment = async (id) => {
    const res = await callApi(
      `/protected/business/${
        selectedBusiness?.id
      }/iorequest?dest=${encodeURIComponent(
        `customer/segment/${id}/business/:BID:/user/:UID:/delete`
      )}`,
      "POST"
    );
    if (res.status) {
      toast.success("Customer segment deleted successfully");
      setCustomerSegments(customerSegments?.filter((el) => el.id !== id));
    } else {
      toast.error("Failed to delete customer segment");
    }
    return res;
  };

  const copySegmentToOtherLocations = async ({ id, businessList }) => {
    const res = await callApi(
      `/protected/business/${
        selectedBusiness?.id
      }/iorequest?dest=${encodeURIComponent(
        `customer/segment/${id}/business/:BID:/user/:UID:/copy`
      )}`,
      "POST",
      { businessList }
    );
    if (res.status) {
      toast.success("Customer segment copied to businesses");
      getCustomerSegments();
    } else {
      toast.error("Failed to copy customer segment");
    }
    return res;
  };

  const bulkUpdateCustomerSegmentPermission = async ({ id, editors }) => {
    const res = await callApi(
      `/protected/business/${
        selectedBusiness?.id
      }/iorequest?dest=${encodeURIComponent(
        `customer/segment/${id}/business/:BID:/user/:UID:/update/permission/bulk`
      )}`,
      "POST",
      { editors }
    );
    if (res?.status) {
      toast.success("Customer segment permission changed successfully");
      getCustomerSegments();
    } else {
      toast.error("Failed to change customer segment permission");
    }
    return res;
  };

  const updateCustomerSegment = async ({
    id,
    name,
    description,
    query_parameters,
    last_searched,
    editors,
  }) => {
    const res = await callApi(
      `/protected/business/${
        selectedBusiness?.id
      }/iorequest?dest=${encodeURIComponent(
        `customer/segment/${id}/business/:BID:/user/:UID:/update`
      )}`,
      "POST",
      { name, description, query_parameters, last_searched, editors }
    );
    if (res.status) {
      const newSegment = res.data;
      updateCache(newSegment);
    }
    return res;
    // else {
    //   toast.error("Failed to update customer segment");
    // }
  };

  useEffect(() => {
    setCustomerSegments(undefined);
  }, [selectedBusiness?.id]);

  return {
    customerSegments,
    addCustomerSegment,
    updateCustomerSegment,
    removeCustomerSegment,
    copySegmentToOtherLocations,
    getCustomerSegments,
    getMultiBusinessSegments,
    bulkUpdateCustomerSegmentPermission,
  };
};
